

































import { isViewAsSelected } from "@/store/modules/TargetUserModule";
import { Vue, Component, Prop, Ref } from "vue-property-decorator";

import { doesClientHaveApp } from "@/data/repository/ClientRepository";
import { ProjectNote } from "@/data/models/ProjectNote";

import ProjectNoteComponent from "@/components/project/notes/ProjectNoteItem.vue";
import ProjectNoteFormComponent from "@/components/project/notes/NoteForm.vue";

import { ProjectDetails } from "@/data/models/ProjectDetails";

@Component({
  components: {
    "project-note": ProjectNoteComponent,
    "project-note-form": ProjectNoteFormComponent,
  },
})
export default class ProjectNotesComponent extends Vue {
  hasApp = doesClientHaveApp();

  @Prop()
  projectDetails!: ProjectDetails;

  @Prop()
  projectNotes!: ProjectNote[];

  @Ref("projectNoteForm")
  projectNoteForm!: ProjectNoteFormComponent;

  async onAddNote() {
    await this.projectNoteForm.show(null);
  }

  get isViewAsReadOnly() {
    return isViewAsSelected();
  }

  async onEditNote(projectNote: ProjectNote) {
    if (this.isViewAsReadOnly) {
      return;
    }

    await this.projectNoteForm.show(projectNote);
  }
}
